module.exports = __webpack_public_path__ + "static/media/pic22.9e74599b.jpg";